import ScalarSidebarItem_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarItem.vue.script.js";
//#region src/components/ScalarSidebar/ScalarSidebarItem.vue
var ScalarSidebarItem_default = ScalarSidebarItem_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarItem_default as default };

//# sourceMappingURL=ScalarSidebarItem.vue.js.map